export default "__VITE_ASSET__afd620b7__"